<template>
    <div>
        <div v-if="tradingAccountList.totalLiveAccounts > 0">
            <div class="mainTitle  text-center my-3"> 
                <h3 class="mb-4">{{$t('depFundAcc')}} <span v-if="account_id!=''"> {{account_id}}</span></h3>
                <complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
                 <message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
            </div> 
        	<!--loader - message---> 
            <div class="fxdepositfund d-flex align-items-center justify-content-center accountList flex-wrap" >
                <!---------------------------step1----------------------------------->
                <div v-for="(list,key) in tradingAccountList.records"   :class="account_id==list.account_id?'accountBox selected':'accountBox'" v-show='shwStep==1' v-if="parseInt(list.demo_live) == 1" v-on:click.stop.prevent="act_account_id = list.act_account_id ; account_id=list.account_id; currency_selected = list.currency; shwOption=false">
                    <div class="head d-flex align-items-center justify-content-between">
                        <div class="platformLogo">
                            <img :src="'../../../../static/fxView/images/'+platformIcon[list.platform]" alt="mt4">
                        </div>
                        <div class="depositNow" @click="account_id=list.account_id;currency_selected = list.currency;  transactionLimitCurrency()">
                            <a >{{$t('depFund')}}</a>
                        </div>
                    </div>
                    <div class="detail">
                        <div class="tradingId">
                            <span>{{$t('tradAccId')}}</span>
                            {{list.account_id}}
                        </div> 
                    </div>
                    <div class="ftr d-flex align-items-center justify-content-between">
                        <div class="accountCurncy">
                           <img :src="'../../../../static/fxView/images/'+list.currency.toLowerCase()+'.svg'" alt="usd">  {{list.currency}}
                        </div>
                        <div class="acntType" v-if="list.demo_live==0">
                           {{$t('demo')}}
                        </div>
                        <div class="acntType" v-if="list.demo_live==1">
                           {{$t('live')}}
                        </div>
                    </div> 
                </div> 
            </div> 
            
            <!---------------------------step2----------------------------------->
            <div class="CustomBlockWidth inMiddle-area whitebox p-4 accountList" v-show='shwStep==2'>  
                <div class="row justify-content-center">
                    <div class="col-12 stepForm">
                        <h4 class="mb-3">{{$t('depAmount')}}</h4>
                        <div class="form-group field-wrapper">
                            <input placeholder=" " type="text" v-model="amount"  v-validate="{ required: true, numeric : true }" name="amount" class="float-field form-control"  :class="{ 'is-invalid': submitted && errors.has('amount') }" autocomplete="off" ref="amountInput" />
                            <label for="password" class="float-label">{{$t('amount')}}</label> 
                            <div class="SpecifyDeposit d-flex justify-content-start align-items-center ">
                                <div :class="amount == 100?'customUserType multiSlct mr-2 selected': 'customUserType multiSlct mr-2'">
                                    <label class="customRadio-button border" @click="amount = 100">
                                        100
                                        <input type="radio" name="radio1" value="100">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div :class="amount == 200?'customUserType multiSlct mr-2 selected': 'customUserType multiSlct mr-2'">
                                    <label class="customRadio-button border" @click="amount = 200">
                                        200
                                        <input type="radio" name="radio1" value="200">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div :class="amount == 500?'customUserType multiSlct mr-2 selected': 'customUserType multiSlct mr-2'">
                                    <label class="customRadio-button border" @click="amount = 500">
                                        500
                                        <input type="radio" name="radio1" value="500">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div :class="amount == 1000?'customUserType multiSlct mr-2 selected': 'customUserType multiSlct mr-2'">
                                    <label class="customRadio-button border" @click="amount = 1000">
                                        1000
                                        <input type="radio" name="radio1" value="1000">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                                <div :class="amount == 2000?'customUserType multiSlct mr-2 selected': 'customUserType multiSlct mr-2'">
                                    <label class="customRadio-button border" @click="amount = 2000">
                                        2000
                                        <input type="radio" name="radio1" value="2000">
                                        <span class="checkmark"></span>
                                    </label>
                                </div>
                            </div>
                            <ul><li v-for="error in errors.collect('amount')" class="error">{{ error }}</li></ul>
							<p class="error" v-if="amount_msz_error != ''">{{amount_msz_error}}</p>
                        </div> 
                        <h4 class="mb-3">{{$t('selPayMethd')}}</h4> 
                        <div class="form-group d-flex  justify-content-start align-items-center field-wrapper mb-3"> 
                            <ul class="twoColumn flex-wrap depositpaymentMethod w-100">
								<template v-if="!OnlyUsers()">
									<li class="mb-2 mr-2" v-for="(list,key) in withdrawalMethod" :class="(parseInt(get_method_id) == parseInt(key))?'selected':''" v-if="(parseInt(key) == 32) || (parseInt(key) < 5) || (parseInt(key) > 5 && 
										dp_mtd_show_acc_User_res_con.hasOwnProperty(getUserProfile.residence_country) && 
										dp_mtd_show_acc_User_res_con[getUserProfile.residence_country].indexOf(parseInt(key)) >= 0 )
										">    
										<label class="customRadio-button d-flex align-item-center"> 
											<div class="lft d-flex align-items-center">
												<img :src="'../../../../static/fxView/images/'+withdrawalMethod[key]" alt="Bank Account" class="mr-2">
											</div>
											<div class="rft">
												<input type="radio"  name="radio" v-validate="{ required: true }"  :value="depositValue[parseInt(key)]" v-model="pay_option"  v-on:change="select_option_method(key)" :class="{ 'is-invalid': submitted && errors.has('radio') }" ref="radioInput">
												<span class="checkmark"></span>
											</div>
										</label>
									</li>
								</template>
                                <!-- <li class="mb-2 mr-2" v-for="(list,key) in withdrawalMethod" :class="(parseInt(get_method_id) == parseInt(key))?'selected':''" v-if="(parseInt(key) != 32) || (parseInt(key) <= 5) || (parseInt(key) > 5 && 
									dp_mtd_show_acc_User_res_con.hasOwnProperty(getUserProfile.residence_country) && 
									dp_mtd_show_acc_User_res_con[getUserProfile.residence_country].indexOf(parseInt(key)) >= 0 )
									">    
                                    <label class="customRadio-button"> 
                                        <div class="lft d-flex align-items-center">
                                        	<img :src="'../../../../static/fxView/images/'+withdrawalMethod[key]" alt="Bank Account" class="mr-2">
                                        </div>
                                        <div class="rft">
                                        	<input type="radio"  name="radio" v-validate="{ required: true }"  :value="depositValue[parseInt(key)]" v-model="pay_option"  v-on:change="select_option_method(key)" :class="{ 'is-invalid': submitted && errors.has('radio') }" ref="radioInput">
	                                        <span class="checkmark"></span>
                                        </div>
                                    </label>
                                </li> -->
								<template v-if="OnlyUsers()">
									<li class="mb-2 mr-2" v-for="(list,key) in withdrawalMethod" :class="(parseInt(get_method_id) == parseInt(key))?'selected':''" v-if="(parseInt(key) == 32) || (parseInt(key) < 5) || (parseInt(key) > 5 &&
										dp_mtd_show_acc_User_res_con.hasOwnProperty(getUserProfile.residence_country) && 
										dp_mtd_show_acc_User_res_con[getUserProfile.residence_country].indexOf(parseInt(key)) >= 0 )
										">    
										<label class="customRadio-button"> 
											<div class="lft d-flex align-items-center">
												<img :src="'../../../../static/fxView/images/'+withdrawalMethod[key]" alt="Bank Account" class="mr-2">
											</div>
											<div class="rft">
												<input type="radio"  name="radio" v-validate="{ required: true }"  :value="depositValue[parseInt(key)]" v-model="pay_option"  v-on:change="select_option_method(key)" :class="{ 'is-invalid': submitted && errors.has('radio') }" ref="radioInput">
												<span class="checkmark"></span>
											</div>
										</label>
									</li>
								</template> 
                            </ul> 
                        </div> 
                        <div class="clearfix"></div>

						<p class="error mb-3" v-if="errors.first('radio')">{{ $t('payFieldReq') }}</p>
                        <div class="clearfix"></div>  
						<!-----------------------bank transfer------------------------->
						<div v-if="parseInt(get_method_id) == 1"> 
							<div>  
								<div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center">
									<div class="list-group-item w-100">
										<span>{{ $t('depMsz1') }}<strong>{{ $t('depMsz2') }}</strong></span>
										<span>{{ $t('depMsz3') }}<strong>{{ $t('depMsz4') }}</strong></span>
									</div>
								</div>
								<div v-if="parseInt(get_method_id) == 1">
									<p class="mb-2">{{ $t('depMsz5') }}</p>
									<div v-for="(list,index) in depositBankListDetail" class=" mb-3">
										<div class="list-group-item head ">
											<div class="d-flex justify-content-between align-items-center">
												<div>
													<p ><span>{{list.region}}</span></p>
													<p v-if="list.region == 'Moneynetint'">{{ $t('warnMsz') }}</p>
													<!--<p v-if="list.Bank_Name == 'Moneynetint'"><span>{{list.region}}</span></p>
													<p>
														<span>{{ $t('bankName') }}</span>  
														<span v-if="list.swift == 'PIRBCY2NXXX'">{{list.Bank_Name}} ({{list.account_currency}})</span>
														<span v-else>{{list.Bank_Name}}</span>
													</p>-->
												</div>
												<div>
													<a href="#" class="green text-nowrap" @click="detailDiv(index);" v-if="index == showIndex">{{ $t('lessDetail') }}</a>
													<a href="#" class="green text-nowrap" @click="detailDiv(index);" v-else>{{ $t('viewDetail') }}</a>
												</div>
											</div>
											<div class="border p-2 mt-2 whiteBG w-100 radius">-
												<p v-if="list.region == 'Moneynetint'">
													<span>{{$t('MiniDepositAmount')}}: <b>&euro; 5000 </b> </span>
												</p>
												<p v-else>
													<span>{{$t('MiniDepositAmount')}}: <b>&euro; 200 </b> </span><br>
												</p>
											</div>
										</div>
										<div class="personalForm list-group mb-3" :ref="'buttons'+index" v-if="index == showIndex">
											<!--<div >
												<div class="list-group-item">
												   <span>IBAN</span>  <span>{{list.IBAN}}</span>
												</div>
												<div class="list-group-item">
												   <span>{{ $t('holderName') }}</span>  <span>{{list.account_holder_name}}</span>
												</div>
												<div class="list-group-item">
												   <span>{{ $t('bankName') }}</span>  <span>{{list.Bank_Name}}</span>
												</div>
												<div class="list-group-item">
												   <span>{{$t('bankAdd')}}</span>  <span>{{list.Bank_Address}}</span>
												</div> 
												<div class="list-group-item">
												   <span>BIC</span>  <span>{{list.BIC}}</span>
												</div>
												<div class="list-group-item">
												   <span>Reference</span>  <span>For trading account {{account_id}}</span>
												</div>
											</div>
											<div v-if="list.swift == 'PIRBCY2NXXX'">
												<div class="list-group-item">
												   <span>IBAN</span>  <span>{{list.IBAN}}</span>
												</div>
												<div class="list-group-item">
												   <span>{{ $t('holderName') }}</span>  <span>{{list.account_holder_name}}</span>
												</div>
												<div class="list-group-item">
												   <span>{{ $t('bankName') }}</span>  <span>{{list.Bank_Name}}</span>
												</div>
												<div class="list-group-item">
												   <span>Country</span>  <span>{{list.Country}}</span>
												</div> 
												<div class="list-group-item">
												   <span>City/Town</span>  <span>{{list.city}}</span>
												</div> 
												<div class="list-group-item">
												   <span>Swift</span>  <span>{{list.swift}}</span>
												</div> 
												<div class="list-group-item">
												   <span>Account Currency</span>  <span>{{list.account_currency}}</span>
												</div>
												<div class="list-group-item">
												   <span>Reference</span>  <span>{{list.reference}} For trading account {{account_id}}</span>
												</div>
											</div>-->
											<div>
												<div class="list-group-item">
												   <span>{{ $t('IBAN') }}</span>  <span>{{list.IBAN}}</span>
												</div>
												<div class="list-group-item">
												   <span>{{ $t('accountNumber') }}</span>  <span>{{list.account_number}}</span>
												</div>
												<div class="list-group-item">
												   <span>{{ $t('holderName') }}</span>  <span>{{list.account_holder_name}}</span>
												</div>
												<div class="list-group-item">
												   <span>{{ $t('bankName') }}</span>  <span>{{list.Bank_Name}}</span>
												</div>
												<div class="list-group-item">
												   <span>{{ $t('Swift') }}</span>  <span>{{list.SWIFT}}</span>
												</div> 
												<div class="list-group-item">
												   <span>{{ $t('address') }}</span>  <span>{{list.address}}</span>
												</div>
												<div class="list-group-item" v-if="list.region == 'Bank of Cyprus'">
												   <span>{{ $t('accountCurr') }}</span>  <span>{{list.account_currency}}</span>
												</div>
												<div class="list-group-item">
												   <span>{{ $t('reference') }}</span>  <span>{{ $t('tradingAcc') }} {{account_id}}</span>
												</div>
											</div>
										</div>
									</div> 
									<!-- <p class="mb-3" v-html="$t('chargedIfdeposit')"></p> -->
									<p class="mb-3" v-if="depositBankListDetail.length > 0">{{ $t('depMsz6') }} <router-link :to="{name: 'fxView.support' , params: { 'tabName':'requestServiceElement','ticketData' : '16','account_id':account_id,'method_id':get_method_id}}">{{ $t('clickHere') }} </router-link> {{ $t('depMsz7') }} </p>
								</div>
								<!-- <div class="mb-3" v-if="!(withdrawalMethodResponse.hasOwnProperty(1)) && depositBankListDetail.length == 0">
									<p>{{ $t('depMsz8') }} <router-link :to="{name: 'fxView.support' , params: { 'tabName':'requestServiceElement','ticketData' : '16','account_id':account_id,'method_id':get_method_id}}">{{ $t('clickHere') }}</router-link> {{ $t('depMsz9') }}</p>
								</div> -->
							</div>
							<!-- <div class="mb-3" v-else>
								<p>{{ $t('DontbankAcc') }} <router-link :to="{name: 'fxView.support' , params: { 'tabName':'requestServiceElement','ticketData' : '16','account_id':account_id,'method_id':get_method_id}}">{{ $t('clickHere') }}</router-link> {{ $t('Createbank') }}</p>
							</div> -->
						</div>
						<!-----------------------------all method Id--------------------------------->
                        <div v-if="[2,3].includes(parseInt(get_method_id)) && !OnlyUsers()"> 
							<div>
								<div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center">
									<div class="list-group-item w-100">
										<span>{{ $t('depMsz1') }}<strong>{{ $t('depMsz10') }}</strong></span>
										<span>{{ $t('depMsz3') }}<strong>{{ $t('depMsz4') }}</strong></span>
									</div>
								</div>
								<div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center">
									<div class="list-group-item w-100">
										<span>{{$t('MiniDepositAmount')}}:<b>{{(currency_selected.toUpperCase() != 'ZAR') ? checkSuccessDeposit() ? 200 : 200 :  checkSuccessDeposit() ?  getLimit() : 3200 }}</b></span>
									</div>
								</div>
							</div>
						</div>
						<!----------------------------- all method Id --------------------------------->
						<div v-if="[5,6,7,8,9,10,32].includes(parseInt(get_method_id)) && !OnlyUsers()">
                            <div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center">
                                <div class="list-group-item w-100">
                                    <span>{{$t('MiniDepositAmount')}}:<b class="">{{(currency_selected.toUpperCase() != 'ZAR') ? checkSuccessDeposit() ? 200 : 200 :  checkSuccessDeposit() ?  getLimit() : 3200 }} </b></span>
                                </div>
                            </div>
						</div>
						<!-----------------------------For only user --------------------------------->
						<div v-if="OnlyUsers() && [2,3,6,7,8,9,10,32].includes(parseInt(get_method_id))">
                            <div class="personalForm list-group mb-3 d-flex justify-content-between align-items-center">
                                <div class="list-group-item w-100">
                                    <span>{{$t('MiniDepositAmount')}}:<b class="">{{(currency_selected.toUpperCase() != 'ZAR') ? checkSuccessDeposit() ? 5 : 5 :  checkSuccessDeposit() ?  getLimit() : 3200 }} </b></span>
                                </div>
                            </div>
						</div>
						<!-------------------------------------------------------------------------->
                        <div class="clearfix"></div> 
						<p class="error" v-if="raised_max_limit_msg != ''">{{raised_max_limit_msg}}</p>
						<!-- <div v-if="parseInt(get_method_id) != 1">
							<div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center" v-if="(parseInt(get_method_id) == 2 && withdrawalMethodResponse != '' && withdrawalMethodResponse.hasOwnProperty(2)) || (parseInt(get_method_id) == 3 && withdrawalMethodResponse != '' && withdrawalMethodResponse.hasOwnProperty(3)) || (parseInt(get_method_id) != 3 && parseInt(get_method_id) != 2)">
								<a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="shwStep=1"><feather class="mr-1" type="chevron-left"></feather> {{$t('backToStep')}}</a>
								<button 
									class="prism_btn btn_sm" 
									v-on:click.stop.prevent="validateValue()" 
									:class="(disabledProced)?'disabled' : ''" 
									v-if=" get_method_id !='' && ((parseInt(get_method_id)==1 && Object.keys(withdrawalMethodResponse).length > 0 && withdrawalMethodResponse.hasOwnProperty(1)) || parseInt(get_method_id)==3 || 
									parseInt(get_method_id)==2 ||
									(parseInt(get_method_id) !=1 && parseInt(get_method_id) !=3 && parseInt(get_method_id) !=2)) "
								>{{$t('procToPay')}}
								</button>
								<button class="prism_btn btn_sm disabled" title="Your account is not verified yet" v-else>{{$t('procToPay')}}</button>
							</div>	
						</div> -->
						<div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center" v-if="parseInt(get_method_id) != 1">
							<a
								class="d-flex align-items-center"
								href="#"
								v-on:click.stop.prevent="
								reset();
								shwStep = 1;
								"
								>
								<feather class="mr-1" type="chevron-left"></feather>
								{{ $t("backToStep") }}
							</a>
							<button
								class="prism_btn btn_sm"
								v-on:click.stop.prevent="validateValue()"
								:class="disabledProced ? 'disabled' : ''"
								v-if=" get_method_id !='' && ((parseInt(get_method_id)==1 && Object.keys(withdrawalMethodResponse).length > 0 && withdrawalMethodResponse.hasOwnProperty(1)) || parseInt(get_method_id)==3 || parseInt(get_method_id)==2 || parseInt(get_method_id)==18 || parseInt(get_method_id) == 23 || parseInt(get_method_id)==24 || parseInt(get_method_id)==25 || parseInt(get_method_id)==26 || parseInt(get_method_id)== 32 || (parseInt(get_method_id) !=1 && parseInt(get_method_id) !=3 && parseInt(get_method_id) !=2)) "
								>
								{{$t("procToPay")}}
							</button>
						</div>
						<p class="error mb-3" v-if="parseInt(get_user.verified_status) != 1">Your account is not verified, We will update you shortly</p>					
                    </div>
                </div> 
            </div> 
			<!------------------for credit card------------------------>
			<div class="CustomBlockWidth inMiddle-area whitebox p-4" v-show='shwStep==5'>  
				<div class="confirmPayment">
					<h3 class="mb-3">{{$t('PleaseEnsureCorrect')}}</h3>
					<!--<p class="mb-5">{{$t('depMsz15')}}</p>-->
					<div class="table-responsive">
						<table class="table w-100 mb-5">
							<thead>
								<tr>
									<th>{{$t('accountId')}}</th>
									<th>{{$t('feeUsd')}}</th>
									<th>{{$t('depositAmount')}}</th>
									<th>{{$t('paymentMethod')}}</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>{{account_id}}</td>
									<td>0</td>
									<td>{{amount}}</td>
									<td>{{depositMethod[get_method_id]}}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
					<a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="shwStep=2"><feather class="mr-1" type="chevron-left"></feather> {{$t('backToStep')}}</a>
					<button class="prism_btn btn_sm" @click="creditCardDepositFunc()">{{$t('procToPay')}}</button>
				</div> 
			</div>
            <div class="CustomBlockWidth inMiddle-area whitebox p-4" v-show='shwStep==6'>  
                <div class="confirmPayment">
                    <h3 class="mb-3">{{$t('conPay')}}</h3>
                    <p class="mb-5">{{$t('depMsz15')}}</p>
                    <div class="table-responsive">
                        <table class="table w-100 mb-5">
                            <thead>
                                <tr>
                                    <th>{{$t('accountId')}}</th>
                                    <th>{{$t('feeUsd')}}</th>
                                    <th>{{$t('depositAmount')}}</th>
                                    <th>{{$t('paymentMethod')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{account_id}}</td>
                                    <td>0</td>
                                    <td>{{amount}}</td>
                                    <td>{{pay_option}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
                    <a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="shwStep=2"><feather class="mr-1" type="chevron-left"></feather> {{$t('backToStep')}}</a>
                    <button class="prism_btn btn_sm" @click="getTransactionId()">{{$t('procToPay')}}</button>
                </div> 
            </div>
			<!------------------for Nuvei ------------------------>
			<div class="CustomBlockWidth inMiddle-area whitebox p-4" v-show='shwStep==32'>  
				<div class="confirmPayment">
					<h3 class="mb-3">{{$t('PleaseEnsureCorrect')}}</h3>
					<div class="table-responsive">
						<table class="table w-100 mb-5">
							<thead>
								<tr>
									<th>{{$t('accountId')}}</th>
									<th>{{$t('feeUsd')}}</th>
									<th>{{$t('depositAmount')}}</th>
									<th>{{$t('paymentMethod')}}</th>
								</tr>
							</thead>
							<tbody>
								<tr>
									<td>{{account_id}}</td>
									<td>0</td>
									<td>{{amount}}</td>
									<td>{{depositMethod[get_method_id]}}</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
					<a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="shwStep=2"><feather class="mr-1" type="chevron-left"></feather> {{$t('backToStep')}}</a>
					<button class="prism_btn btn_sm" @click="nuveiDepositFunc()">{{$t('procToPay')}}</button>
				</div> 
			</div>
			<!--------------------------------------------------------->
			<form action="https://pay.skrill.com" method="post" target="_self" id="skrillForm">
				<!---------------step3----------------------->
				<div class="CustomBlockWidth inMiddle-area whitebox p-4" v-show='shwStep==3'>  
					<div class="confirmPayment">
						<h3 class="mb-3">{{$t('PleaseEnsureCorrect')}}</h3>
						<!--<p class="mb-5">{{$t('depMsz15')}}</p>-->
						<div class="table-responsive">
							<table class="table w-100 mb-5">
								<thead>
									<tr>
										<th>{{$t('accountId')}}</th>
										<th>{{$t('feeUsd')}}</th>
										<th>{{$t('depositAmount')}}</th>
										<th>{{$t('paymentMethod')}}</th>
									</tr>
								</thead>
								<tbody>
									<tr>
										<td>{{account_id}}</td>
										<td>0</td>
										<td>{{amount}}</td>
										<td>{{depositMethod[get_method_id]}}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<input type="hidden" name="pay_to_email" value="accounts.cy@fxview.com">
					<input type="hidden" name="pay_from_email" :value="get_user.email">
					<input type="hidden" name="status_url" value="https://tptservice.fxview.com/payment/resp">
                    <!-- <input type="hidden" name="status_url" value="https://dev.finvasia.com:7050/payment/resp"> -->
					<input type="hidden" name="return_url" :value="depositLink">
                    <input type="hidden" name="firstname" :value="get_user.profile.firstname">
                    <input type="hidden" name="lastname" :value="get_user.profile.lastname">
                    <input type="hidden" name="merchant_id" value="115389550">                
					<input type="hidden" name="language" value="EN">
					<input type="hidden" name="amount" :value="amount">
					<input type="hidden" name="currency" :value="currency_selected">
                    <input type="hidden" name="payment_methods" :value="pay_option"> 
					<input type="hidden" name="email" :value="get_user.email"> 
					<input type="hidden" name="merchant_fields" value="tradingAccount,email,method_id"> 
					<input type="hidden" name="tradingAccount" :value="account_id">
                    <input type="hidden" name="method_id" :value="get_method_id">
					<input type="hidden" name="return_url_target" value="3">
					<input type="hidden" name="cancel_url_target" value="3">
                    <input type="hidden" name="transaction_id" :value="transaction_id">
					<input type="hidden" name="detail1_description" :value="'Deposit in '+account_id">
					<input type="hidden" name="detail1_text" value="Payment for account id">
					<div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
						<a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="shwStep=2"><feather class="mr-1" type="chevron-left"></feather> {{$t('backToStep')}}</a>
                         <button class="prism_btn btn_sm" v-on:click.stop.prevent="getTransactionId()">{{$t('procToPay')}}</button>
						<!-- <button class="prism_btn btn_sm">{{$t('procToPay')}}</button> -->
					</div> 
				</div>
				<!-- 
                Comment By jatin
                Why we need below code. Let me know and then uncomment
                <div class="CustomBlockWidth inMiddle-area whitebox p-4" v-show='shwStep==4'>  
                    <div class="confirmPayment">
                        <h3 class="mb-3">{{$t('conPay')}}</h3>
                        <p class="mb-5">{{$t('depMsz15')}}</p>
                        <div class="table-responsive">
                            <table class="table w-100 mb-5">
                                <thead>
                                    <tr>
                                        <th>{{$t('accountId')}}</th>
                                        <th>{{$t('feeUsd')}}</th>
                                        <th>{{$t('depositAmount')}}</th>
                                        <th>{{$t('paymentMethod')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>{{account_id}}</td>
                                        <td>0</td>
                                        <td>{{amount}}</td>
                                        <td>{{pay_option}}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <input type="hidden" name="pay_to_email" value="demoqco@sun-fish.com">
                    <input type="hidden" name="pay_from_email" value="daniela.egli@icmtrader.eu">
                    <input type="hidden" name="status_url" value="https://dev.finvasia.com:7050/payment/resp">
                    <input type="hidden" name="firstname" :value="get_user.profile.firstname">
                    <input type="hidden" name="lastname" :value="get_user.profile.lastname">
                    <input type="hidden" name="return_url" :value="depositLink">
                    <input type="hidden" name="language" value="EN">
                    <input type="hidden" name="amount" :value="amount">
                    <input type="hidden" name="currency" :value="currency_selected">
                    <input type="hidden" name="payment_methods" :value="pay_option"> 
                    <input type="hidden" name="email" :value="get_user.email"> 
                    <input type="hidden" name="merchant_fields" value="tradingAccount,email,method_id"> 
                    <input type="hidden" name="tradingAccount" :value="account_id">
                    <input type="hidden" name="return_url_target" value="3">
                    <input type="hidden" name="cancel_url_target" value="3">
                    <input type="hidden" name="transaction_id" :value="transaction_id">
                    <input type="hidden" name="method_id" :value="get_method_id">
                    <input type="hidden" name="detail1_description" :value="'Deposit in '+account_id">
                    <input type="hidden" name="detail1_text":value="'Deposit in '+account_id">
                    <div class="submitButton d-flex justify-content-between align-items-center w-100 mt-2 text-center">
                        <a class="d-flex align-items-center" href="#" v-on:click.stop.prevent="shwStep=2"><feather class="mr-1" type="chevron-left"></feather> {{$t('backToStep')}}</a>
                        <button class="prism_btn btn_sm" v-on:click.stop.prevent="getTransactionId()">{{$t('procToPay')}}</button>
                    </div> 
                </div> -->
			</form> 
        </div>
        <div v-else-if="tradingAccountList.totalLiveAccounts == 0">
            <div class="mainTitle  text-center my-3">
                <h3>{{$t('noTradingAccFound')}}</h3>
            </div>
            <no-trading-account></no-trading-account>
        </div>
		<div v-else class="text-center p-5 customLoader"> 
			<div class="loader"></div>  
            <h4>{{$t('plzWaitWhileProc')}}</h4>
        </div>
    </div>
</template>
<script>
    import { fxViewMixins } from '@/plugins/fxView'
    import { Const } from '@/plugins/fxView/provider/candle-history/lib/const.cls'
    import moment from 'moment'
    export default {
        name: 'Deposit',
        mixins: [fxViewMixins],
        data() {
            return {
                //============message and loader ===========
                response_msg : '',
                msg_type : '',
                pageLoader : false,
                loaderFuncRun : '1',
                //==========================================
                account_id : '',
				act_account_id : '',
                amount : '',
                submitted : false,
                shwOption: true,
                shwStep : 1,
                account_number : '',
                pay_option:'',
                description: "Payment for account id",
                get_method_id : '',
                currency_selected: 'USD',
                method_id: '',
                transaction_id: "-1",
				platformIcon : {'MT4' : 'platforn-icon-1.svg' , 'MT5' : 'platforn-icon-3.svg','ACT' : 'platforn-icon-2.svg'},
				showIndex : '-1',
				
				disabledProced : false,
				responseTransLimitDataNew: {
                    "1": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                    "2": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                    "3": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                    "4": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                    "5": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                    "6": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                    "7": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                    "8": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
					"10": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                    "17": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                    "18": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                    "23": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                    "25": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                    "24": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                    "26": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                    "27": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                    "31": { "MONTHLY": "25000", "DAILY": "50000", "PERTXN": "50000" },
                    "32": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                    "33": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                    "37": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                    "38": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                    "39": { "MONTHLY": "25000", "DAILY": "15000", "PERTXN": "5000" },
                },
				responseTransLimitData : {
					"1":{"MONTHLY":"25000","DAILY":"15000","PERTXN":"5000"},
					"2":{"MONTHLY":"25000","DAILY":"15000","PERTXN":"5000"},
					"3":{"MONTHLY":"25000","DAILY":"15000","PERTXN":"5000"},
					"4":{"MONTHLY":"25000","DAILY":"15000","PERTXN":"5000"},
					"5":{"MONTHLY":"25000","DAILY":"15000","PERTXN":"5000"},
					"6":{"MONTHLY":"25000","DAILY":"15000","PERTXN":"5000"},
					"7":{"MONTHLY":"25000","DAILY":"15000","PERTXN":"5000"},
					"8":{"MONTHLY":"25000","DAILY":"15000","PERTXN":"5000"},
					"32":{"MONTHLY":"25000","DAILY":"15000","PERTXN":"5000"},
				},
				MinValue : '',
				depositMinAllowedValue : {
					1: {'min_amount' : 500},
					2: {'min_amount' : 200},
					3: {'min_amount' : 200},
					5: {'min_amount' : 200},
					6: {'min_amount' : 200},
					7: {'min_amount' : 200},
					8: {'min_amount' : 200},
					9: {'min_amount' : 200},
					10: {'min_amount' : 200},
					32: {'min_amount' : 200}
				},
				depositMinAllowedValueOnly : {
					1: {'min_amount' : 500},
					2: {'min_amount' : 5},
					3: {'min_amount' : 5},
					5: {'min_amount' : 5},
					6: {'min_amount' : 5},
					7: {'min_amount' : 5},
					8: {'min_amount' : 5},
					9: {'min_amount' : 5},
					10: {'min_amount' : 5},
					32: {'min_amount' : 5}
				},
				limit : '5',
				
				raised_max_limit_msg : '',
				amount_msz_error : '',


				dp_mtd_show_acc_User_res_con :{
					'SE' : [8,9],
					'DE' : [6,8,10],
					'PL' : [7,8],
					'BE' : [8,10],
					'IT' : [8,10],
					'NL' : [8,10],
					'ES' : [8,10],
					'AT' : [8,10],
					'BG' : [8],
					'DK' : [8],
					'EE' : [8],
					'FI' : [8],
					'FR' : [8],
					'GR' : [8],
					'HU' : [8],
					'LV' : [8],
					'PT' : [8],
					'NO' : [8]

				},

				depositValue : {1 : '1', 2:'WLT', 3 :'NTL', 5 : 'CC', 6 : 'GIR', 7 : 'PWY', 8 : 'OBT', 9 : 'EBT', 10 : 'SFT', 32 : 'CC',},

				currencyIcon :{'EUR' : '€','USD' : '$','GBP' : '£','CHF' : 'CHF','JPY' : '¥','AUD': '$'},
				//v-if="getUserProfile.residence_country == 'PL'"
            }
        },
		watch: {
			get_method_id: function (val) {
				this.amount_msz_error = ''
				if(parseInt(this.responseTransLimitDataNew[this.get_method_id].MONTHLY) == 0){

					this.raised_max_limit_msg = "you have raised max limit of transaction per month"
					this.disabledProced = true
				}else{
					this.raised_max_limit_msg = ''
					if(this.responseTransLimitDataNew[this.get_method_id].DAILY < this.responseTransLimitDataNew[this.get_method_id].PERTXN){
						this.MinValue =  this.responseTransLimitDataNew[this.get_method_id].DAILY
					}else{
						this.MinValue =  this.responseTransLimitDataNew[this.get_method_id].PERTXN
					}
					this.disabledProced = false
				}
			},
			amount: function (val) {
                if (this.checkSuccessDeposit()) {
					if ((parseInt(this.get_method_id) == 18 || parseInt(this.get_method_id) == 3 || parseInt(this.get_method_id) == 2) && parseFloat(this.amount) >= this.limit) {
                        this.amount_msz_error = "";
                    } else if ([27].includes(parseInt(this.get_method_id)) && parseFloat(this.amount) >= parseFloat(this.depositMinAllowedValue[parseInt(this.get_method_id)].min_amount)) {
                        this.amount_msz_error = "";
                    } else{
						this.amount_msz_error = '';
					}
                } else if (![24, 27].includes(parseInt(this.get_method_id))) {
					this.amount_msz_error = ""
                } else{
                    this.amount_msz_error = ""
                }
            },
		},
        methods:{
			OnlyUsers() {
                // const getuser = [681,13066,2254, 12631].includes(this.get_user.profile.user_id);
                const getuser = [681].includes(this.get_user.profile.user_id);
                return getuser;
            },
			transactionLimitCurrency(){
				this.$trackEvent('CP+Account+Funding+Deposit');
				let input_json={
					'globalParams' :{
						'currency' : this.currency_selected,
					},
					'localParams' :{ "parameter" : this }
				}
				this._runTransactionLimitCurrency(input_json)
			},
			detailDiv(index) {
				if(this.showIndex == index){
					this.showIndex =  '-1'
				}else{
					this.showIndex = index
				}              
            },
            select_option_method(getData){
                this.get_method_id = getData;
				this.amount = "";
            },
			creditCardDepositFunc(){
				let input_json={
					'globalParams' :{
						'amount' : this.amount,
						'currency' : this.currency_selected,
						'account_id' : this.account_id 
					},
					'localParams' :{ "parameter" : this }
				}
				this._runCreditCardDeposit(input_json)
			},
			nuveiDepositFunc(){
				let input_json={
					'globalParams' :{
						'amount' : this.amount,
						'currency' : this.currency_selected,
						'account_id' : this.account_id ,
						'method_id': this.get_method_id
					},
					'localParams' :{ "parameter" : this }
				}
				this._runNuveiRequest(input_json)
			},
            submitPay(transaction_id){
                // alert(transaction_id)
                this.transaction_id = transaction_id

                setTimeout(function(){ 
                    document.getElementById("skrillForm").submit();
                }, 3000);
            },
            getTransactionId(){
                let input_json={
                    'globalParams' :{
                        'amount' : this.amount,
                        'currency' : this.currency_selected,
                        'account_id' : this.account_id,
                        'method_id': this.get_method_id
                    },
                    'localParams' :{ "parameter" : this }
                }
                if(parseInt(this.get_method_id) == 3){
                 	/*input_json.globalParams['payment_method_email'] = this.withdrawalMethodResponse[this.get_method_id][0].online_payment_id*/
                 	input_json.globalParams['payment_method_email'] = this.withdrawalMethodResponse[this.get_method_id] ? this.withdrawalMethodResponse[this.get_method_id][0].online_payment_id : ""
                }
                this._runCreditCardDeposit(input_json)
            },
            getLimit(){
            	const _that = this
            	if(_that.currency_selected.toUpperCase() == 'ZAR'){
	            	if(parseInt(_that.get_method_id) == 1){
						return '3200'
					} else if(parseInt(_that.get_method_id) == 2 || parseInt(_that.get_method_id) == 3){
						return '160'
					}else if(parseInt(_that.get_method_id) == 8 || parseInt(_that.get_method_id) == 5 || parseInt(_that.get_method_id) == 10 || parseInt(_that.get_method_id) == 6 || parseInt(_that.get_method_id) == 7 || parseInt(_that.get_method_id) == 9 || parseInt(_that.get_method_id) == 32){
						return '80 '
					}
            	} else if ([681].includes(this.get_user.profile.user_id)) {
					console.log("1 get-limit")
            		return _that.depositMinAllowedValueOnly[parseInt(_that.get_method_id)].min_amount
            	} else {
            		return _that.depositMinAllowedValue[parseInt(_that.get_method_id)].min_amount
            	}
            },
            validateValue(){
                const _that = this
                this.submitted = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                    	if(this.checkSuccessDeposit()){
                    		if(parseFloat(this.amount) <= parseFloat(this.MinValue)){
								this.amount_msz_error = ''
								if(this.currency_selected.toUpperCase() == 'ZAR'){
									if(parseInt(_that.get_method_id) == 1){
										this.limit = 3200
									} else if(parseInt(_that.get_method_id) == 2 || parseInt(_that.get_method_id) == 3){
										this.limit = 160
									}else if(parseInt(_that.get_method_id) == 8 || parseInt(_that.get_method_id) == 5 || parseInt(_that.get_method_id) == 10 || parseInt(_that.get_method_id) == 6 || parseInt(_that.get_method_id) == 7 || parseInt(_that.get_method_id) == 9 || parseInt(_that.get_method_id) == 32){
										this.limit = 80 
									}
								} else if ([681, 12631].includes(this.get_user.profile.user_id)) {
									this.limit = parseInt(_that.depositMinAllowedValueOnly[parseInt(_that.get_method_id)].min_amount)
								} else{
									this.limit = parseInt(_that.depositMinAllowedValue[parseInt(_that.get_method_id)].min_amount)
								}
								if(parseInt(this.amount) < parseInt(this.limit)){
									if(this.currency_selected.toUpperCase() == 'ZAR'){
										this.amount_msz_error = "Minimum Deposit Amount: "+ this.limit+" "+ this.currency_selected
									}else if ([681].includes(this.get_user.profile.user_id)){
										this.amount_msz_error = "Minimum Deposit Amount: "+ this.limit +" "+ this.currency_selected
									} else {
										this.amount_msz_error = "Minimum Deposit Amount: "+ this.limit +" "+ this.currency_selected
									}
								} else if(parseInt(this.amount)==0){
									this.amount_msz_error = "Minimum Deposit Amount: "+ _that.depositMinAllowedValue[parseInt(_that.get_method_id)].min_amount +" "+ this.currency_selected
								} else if(parseInt(this.amount)==0 && [681,12631].includes(this.get_user.profile.user_id)){
									this.amount_msz_error = "Minimum Deposit Amount: "+ _that.depositMinAllowedValueOnly[parseInt(_that.get_method_id)].min_amount +" "+ this.currency_selected
								} else{
									this.amount_msz_error = ''
									if(parseInt(this.get_method_id) == 5){
										this.shwStep = 5
									} else if(parseInt(this.get_method_id) == 3){
										this.shwStep = 6
									} else if(parseInt(this.get_method_id) == 32){
										this.shwStep = 32
									} else{
										this.shwStep = 3
									}
								}
							} else{
								this.amount_msz_error = "you can deposit maximum amount =  "+ this.MinValue +" " + this.currency_selected
							}
						} else {
							if(this.currency_selected.toUpperCase() == 'ZAR'){
								if(parseFloat(this.amount) <= parseFloat(this.MinValue)){
									this.amount_msz_error = ''
								if(parseInt(this.amount) < 3200){
									this.amount_msz_error = "Minimum Deposit Amount: "+ 3200+" "+ this.currency_selected
								} else if(parseInt(this.amount)==0){
									this.amount_msz_error = "Minimum Deposit Amount: "+ 3200 +" "+ this.currency_selected
								} else{
									this.amount_msz_error = ''
									if(parseInt(this.get_method_id) == 5){
										this.shwStep = 5
									}
									else if(parseInt(this.get_method_id) == 3){
										this.shwStep = 6
									} else if(parseInt(this.get_method_id) == 32){
										this.shwStep = 32
									} else{
										this.shwStep = 3
									}
								}
								} else{
									this.amount_msz_error = "you can deposit maximum amount =  "+ this.MinValue +" " + this.currency_selected
								}
							} 
							else if ([681].includes(this.get_user.profile.user_id)) {
								if(parseFloat(this.amount) <= parseFloat(this.MinValue)){
									this.amount_msz_error = ''
								if(parseInt(this.amount) < 5){
									this.amount_msz_error = "Minimum Deposit Amount: "+ 5+" "+ this.currency_selected
								} else if(parseInt(this.amount)==0) {
									this.amount_msz_error = "Minimum Deposit Amount: "+ 5 +" "+ this.currency_selected
								} else{
									this.amount_msz_error = ''
									if(parseInt(this.get_method_id) == 5){
										this.shwStep = 5
									} else if(parseInt(this.get_method_id) == 3){
										this.shwStep = 6
									} else if(parseInt(this.get_method_id) == 32){
										this.shwStep = 32
									} else{
										this.shwStep = 3
									}
								}
								} else {
									this.amount_msz_error = "you can deposit maximum amount =  "+ this.MinValue +" " + this.currency_selected
								}
							} else {
								if(parseFloat(this.amount) <= parseFloat(this.MinValue)){
									this.amount_msz_error = ''
								if(parseInt(this.amount) < 200){
									this.amount_msz_error = "Minimum Deposit Amount: "+ 200+" "+ this.currency_selected
								} else if(parseInt(this.amount)==0){
									this.amount_msz_error = "Minimum Deposit Amount: "+ 200 +" "+ this.currency_selected
								} else{
									this.amount_msz_error = ''
									if(parseInt(this.get_method_id) == 5){
										this.shwStep = 5
									} else if(parseInt(this.get_method_id) == 3){
										this.shwStep = 6
									} else if(parseInt(this.get_method_id) == 32){
										this.shwStep = 32
									} else{
										this.shwStep = 3
									}
								}
								} else{
									this.amount_msz_error = "you can deposit maximum amount =  "+ this.MinValue +" " + this.currency_selected
								}
							}
						}
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                })
            },
            submit(){
                const _that = this
                this.submitted = true;
                this.$validator.validate().then(valid => {
                    if (valid) {
                        let input_json={
                            'globalParams' :{
                                'account_id' : _that.account_id ,
								'act_account_id' : _that.act_account_id,
                                'amount' : _that.amount ,
                                'comment' : 'deposit'
                            },
                            'localParams' :{ "parameter" : _that }
                        }
                        _that._runDemoDeposit(input_json)
                    }else{
                        _that.handleValidationErrorAdvanced(_that.errors)
                    }
                });
            },
            reset(){
                this.account_id = ''
				this.act_account_id = ''
                this.amount = ''
                this.submitted = false
            },
            callNeteller(){
                paysafe.checkout.setup("c2luZ2xldXNlLXBtbGUtMzAwMDUyOkItcDEtMC01ZjBkOGJjNC0wLTMwMmMwMjE0NTM3NmUyZmI1MTk2NTc4NGI3MzU4YzA2MDMyMDNiNzY5ODAzMjZkZTAyMTQ3OWFlYTExODA4NTkzMTRhOTRjNjM5YjcwYjM5MDNlYzMyMDQ5MzQ4", {
                    "currency": this.currency_selected,
                    "amount": this.amount,
                    "locale": "en_US",
                    "customer": {
                        "firstName": this.get_user.profile.firstname,
                        "lastName": "KC",
                        "email": "accounts.cy@fxview.com",
                        "phone": this.get_user.mobile_no,
                        "dateOfBirth": {
                            "day": 1,
                            "month": 7,
                            "year": 1990
                        }
                    },
                    "billingAddress": {
                        "street": "George Street",
                        "street2": "3 Edgar Buildings",
                        "city": "Bath",
                        "zip": "BA10BD8",
                        "country": "IN",
                        "state": "JI"
                    },
                    "environment": "TEST",
                    "companyName":"Fxivew",
                    "merchantRefNum": "1559900597607",
                    "canEditAmount": false,
                    "payout":true, 
                    "payoutConfig":{
                        "maximumAmount": 100000
                    },
                    "paymentMethodDetails": {
                        "neteller": {
                            "consumerId": "accounts.cy@fxview.com"
                        }
                    }
                }, 
                function(instance, error, result) {
                    if (result && result.paymentHandleToken) {
                        // console.log(result.paymentHandleToken);
                        // make AJAX call to Payments API
                    } else {
                        console.error(error);
                        // Handle the error
                    }
                }, 
                function(stage, expired) {
                    switch(stage) {
                        case "PAYMENT_HANDLE_NOT_CREATED": // Handle the scenario
                        case "PAYMENT_HANDLE_CREATED": // Handle the scenario
                        case "PAYMENT_HANDLE_REDIRECT": // Handle the scenario
                        case "PAYMENT_HANDLE_PAYABLE": // Handle the scenario
                        default: // Handle the scenario
                    }
                });
                //this will be call on the backend
            },
            listing(){
                let inputJson = {
                    'globalParams' : {
                        filter: {},
                        sort: [],
                        search: '',
                        page: 1,
                        perPage: 15,
                    } ,'localParams' : {'parameter' : this , 'loaderFuncRun' : this.loaderFuncRun}
                }
                this._runGetDepositList(inputJson)
            },
            checkSuccessDeposit(){
		      if(this.depositList.totalRecords){
		        let data = this.depositList.records.filter(val => parseInt(val.payment_status) == 1)
		        if(data.length > 0){
		          return true
		        }else{
		          return false
		        }
		      }
		    },
        },
        created(){
			// Function to remove query parameters from the current URL
			function removeQueryParameters() {
                // Get the current URL
                let currentUrl = window.location.href;
                // Check if the URL has any query parameters
                if (currentUrl.includes('?')) {
                    // Remove the query parameters by taking the part of the URL before the '?'
                    currentUrl = currentUrl.split('?')[0];
                    // Update the browser URL without reloading the page
                    window.history.replaceState({}, document.title, currentUrl);
                }
            }
            if (this.$route.path == '/deposit') {
                removeQueryParameters();
            }
        	this.listing()
            if(this.$store.getters[Const.GET_WITHDRAWAL_METHOD_RESPONSE] != ''){
                this.loaderFuncRun = '0'
            }
            this._runGetWithdrawalMethods({'globalParams' :{},'localParams' :{"parameter" : this, 'loaderFuncRun' : this.loaderFuncRun } })
            this._runGetUserCanDeposit({'globalParams' :{},'localParams' :{ "parameter" : this } })
            //===comes from manage-account-page
            if(this.$route.params.account_id){
                this.account_id = this.$route.params.account_id
				this.act_account_id = this.$route.params.act_account_id
                this.currency_selected = this.$route.params.currency
                this.shwStep = 2
                this.transactionLimitCurrency()
            }
            //comes from ticket add new bank page
            if(this.$route.params.account_id_from_ticket){
                this.shwStep = 2
                this.response_msg = 'suceessMsz20'
                this.msg_type =  'success'
                this.account_id = this.$route.params.account_id_from_ticket
            }
			//comes back from credit card deposit page
			let query = Object.assign({}, this.$route.query);
            if(this.$route.query.msg){
                if(query.msg == 'success'){
					this.response_msg = 'deposit done successfully'
					this.msg_type =  'success'
				}else if(query.msg == 'fail'){
					this.response_msg = 'deposit failed'
					this.msg_type =  'error'
				} 
                delete query.msg;
				
                this.$router.replace({ query });
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/fxView/deposit/deposit.vue